import React from 'react';
import { Drawer, List, ListItem, makeStyles } from '@material-ui/core';
import { compose } from '../../../utils/compose';
import {connect} from 'react-redux';
import PetsLink from './NavigationItems/PetsLink';
import logo from '../../../assets/11pets_logo_light.png'

const useStyles = makeStyles(theme => ({
  logo: {
    textAlign: 'center',
    height: '128px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  logoImage: {
    maxHeight: '64px',
    flexShrink: 0
  }
}));

const PetsSideDrawer = (props) => {
  const classes = useStyles();
  const { menu, dispatch, ...other } = props;

  const menuItems = menu.map(e => {
    return (
      <PetsLink name={e.name} path={e.path} icon={e.icon} key={e.path} />
    )
  })

  return (
    <Drawer variant="permanent" {...other}>
      <div className={classes.logo}>
        <img className={classes.logoImage} src={logo} alt="logo" />
      </div>
      <List component="nav" aria-labelledby="main menu">
        {menuItems}
      </List>
    </Drawer>
  );
};

const mapStateToProps = state => {
  return {
    menu: state.navigation.menu
  }
}

const composed = compose(
  connect(mapStateToProps)
)(PetsSideDrawer)

export default composed;